import { paths } from '@/routes/paths'
import { useState, useEffect } from 'react'
import { useRouter } from '@/routes/hooks/use-router'

import { useAuthContext } from '../auth-provider'

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode
}

export function AuthGuard({ children }: Props) {
  const router = useRouter()

  const { authenticated, loading, user } = useAuthContext()

  const [isChecking, setIsChecking] = useState<boolean>(true)

  const checkPermissions = async (): Promise<void> => {
    if (loading) {
      return
    }

    if (!authenticated) {
      router.replace(paths.login)
    } else {
      setIsChecking(false)
    }
  }

  useEffect(() => {
    checkPermissions()
  }, [authenticated, loading, user])

  if (isChecking) {
    return null
  }

  return <>{children}</>
}
